import { Controller } from '@hotwired/stimulus';
import { transliterate } from "@/utilities/text_helpers";

export default class extends Controller {
  static targets = ["option"]

  reveal(event) {
    const value = transliterate(event.currentTarget.value).toLowerCase()
    this.optionTargets.forEach((option) => {
      if (option.checked) return

      const label = option.nextElementSibling
      const labelText = transliterate(label.innerText).toLowerCase()
      if (labelText === value) {
        option.parentNode.classList.remove("hidden")
        option.checked = true
      }
    })
  }

  hide(event) {
    const checkbox = event.currentTarget
    if (checkbox.checked) return

    checkbox.parentNode.classList.add("hidden")
  }
}
